import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { Link } from 'ui-kit/actions/link/Link'
import { Carousel } from 'routes/components/Shared/Carousel'
import { BadgesG2 } from 'routes/components/Features/BadgesG2/BadgesG2'
import { customerLogosData } from 'routes/components/Features/Companies/CustomerLogos/customerLogosData'
import { bookADemoDescriptionData } from './bookADemoDescriptionData'
import classes from './BookADemoDescription.module.scss'

export const BookADemoDescription = () => {
  return (
    <Block as={'section'} className={classes.section}>
      <Heading as={'h1'} size={'xxl'} center balance className={classes.title}>
        Skip the sales pitch — get a tailored demo
      </Heading>
      <Advantages />
      <Companies />
    </Block>
  )
}

const Advantages = () => {
  return (
    <div className={classes.advantages}>
      <Text size={'lg'} center balance className={classes.subtitle}>
        We don't do generic presentations. Here's what to expect:
      </Text>
      <ul className={classes.list}>
        {bookADemoDescriptionData.map(({ text }, idx) => (
          <li className={classes.item} key={idx}>
            <Text as={'span'} size={'lg'} className={classes.text}>
              {text}
            </Text>
          </li>
        ))}
      </ul>
    </div>
  )
}

const Companies = () => {
  return (
    <div className={classes.companies}>
      <Text size={'lg'} center className={classes.caption}>
        Trusted by 100+ SaaS companies:
      </Text>
      <Slider />
      <BadgesG2 hideG2Link className={classes.badges} />
    </div>
  )
}

const Slider = () => {
  return (
    <Carousel
      className={classes.slider}
      infinite
      autoWidth
      disableDotsControls
      disableButtonsControls
      autoPlay
      autoPlayInterval={0}
      animationDuration={2000}
      animationEasingFunction='linear'
      items={customerLogosData}
    >
      {customerLogosData.map(({ name, url, Logo }, index) => {
        return (
          <div className={classes.slide} key={index}>
            <Link
              aria-label={name}
              href={url}
              target='_blank'
              className={classes.link}
            >
              <Logo aria-labelledby={name} />
            </Link>
          </div>
        )
      })}
    </Carousel>
  )
}
